import { makeStyles } from "@material-ui/core";

export const css = makeStyles((theme) => ({
    root: {
        width: "100%",
        maxWidth: "900px",
        margin: "50px",
    },
    input_grid: {
        display: "flex",
        alignItems: "center",
        gap: "30px",
    },
    input: {
        width: "445px",
        borderRadius: "4px",
        color: theme.palette.text.primary,
    },
    label: {
        color: theme.palette.text.primary,
    },
    title: {
        height: "48px",
        color: theme.palette.primary.main,
    },
    adicionar_produto: {
        display: "flex",
        justifyContent: "right",
        maxHeight: "36.5px",
    },
    button_enviar_ficha: {
        display: "flex",
        justifyContent: "right",
    },
}));
